import MainLayout from '@/shared/Layouts/MainLayout'
import css from '@/pages/Organizations/organizations.module.css'
import Breadcrumbs from 'src/navigation/components/NavigationBreadcrumbs'
import { useParams } from 'react-router-dom'
import useOrganization from '@/pages/Organizations/hooks/useOrganization.ts'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import SearchInput from '@/shared/Inputs/SearchInput'
import { useState } from 'react'
import OrganizationUsersTable from '@/pages/Users/components/OrganiaztionUsersTable'
import CreateUserSidePage from '@/pages/Users/components/CreateUserSidePage'
import ProtectedContent from '@/services/rights/ProtectedContent'
import useDebounce from '@/shared/hooks/useDebounce.ts'
import useTitle from '@/shared/hooks/useTitle'

const OrganizationUsers = () => {
  const organizationId = +useParams().id
  const { organization } = useOrganization(organizationId)
  useTitle(organization?.name ? `Сотрудники — ${organization.name}` : 'Сотрудники')

  const [search, setSearch] = useState('')
  const [createUserSidePageOpen, setCreateUserSidePageOpen] = useState(false)

  const debouncedSearch = useDebounce(search)

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <div className="flex-lines gap16 height100">
          <Breadcrumbs
            lastMatch={{
              id: organizationId.toString(),
              pathname: `/settings/organizations/${organizationId}/users`,
              handle: { canNavigate: false, crumb: () => organization?.name || 'Загрузка..' },
            }}
          />
          <div className="flex-lines gap4">
            <h2 className="text-heading-3">{organization?.name}</h2>
          </div>
          <div className={css.mainCard}>
            <div className="inline-flex-gap gap8">
              <ProtectedContent requiredRight="users:create">
                <CreateEntityButton onClick={() => setCreateUserSidePageOpen(true)} text="Добавить сотрудника" />
              </ProtectedContent>
              <SearchInput value={search} name="search" onChange={setSearch} placeHolder="Поиск по сотрудникам" />
            </div>
            <OrganizationUsersTable organizationId={organizationId} searchQuery={debouncedSearch} />
          </div>
        </div>
      </div>
      <CreateUserSidePage
        open={createUserSidePageOpen}
        organizationId={organizationId}
        onClose={() => setCreateUserSidePageOpen(false)}
      />
    </MainLayout>
  )
}

export default OrganizationUsers
